import { Component, h, Host, Prop } from '@stencil/core';
import { pageHeaderConfiguration } from "./page-header-data";

@Component({
  tag: 'lk-page-header'
})
export class PageHeader {

  @Prop() headerTitle: string = "";
  @Prop() headerLead: string = "";
  @Prop() headerName: string = "DarkBlue";

  render() {
    const config = pageHeaderConfiguration[this.headerName]
    return (
      <Host role="banner" class="lk-page-header" style={{ "background-color": config.backgroundColor }}>
        <div class="lk-page-header__row">
          <div class="lk-page-header__row__content">
            <h1 class="lk-page-header__row__content__header" style={{ "color": config.headerColor }}>
              {this.headerTitle}
              <slot />
              <slot name="h" />
              <slot name="header" />
              <slot name="heading" />
            </h1>
            <p class="paragraph--lead" style={{ "color": config.headerColor }}>
              {this.headerLead}
              <slot name="p" />
              <slot name="lead" />
              <slot name="ingress" />
            </p>
          </div>
          <div class="lk-page-header__row__figure">
            <lk-figure figure-name={config.figurename}></lk-figure>
          </div>
        </div>
      </Host >
    );
  }
}
